/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Component } from 'react';
import PropTypes from "prop-types";
export class OuiDelayRender extends Component {
  static defaultProps = {
    delay: 500
  };
  toBeDelayed = true;
  constructor(props) {
    super(props);
    this.state = {
      toggle: false
    };
  }
  shouldUpdate() {
    this.setState(({
      toggle
    }) => ({
      toggle: !toggle
    }));
  }
  startDelaying = () => {
    window.clearTimeout(this.delayID);
    this.toBeDelayed = true;
    this.delayID = window.setTimeout(this.stopDelaying, this.props.delay);
  };
  stopDelaying = () => {
    window.clearTimeout(this.delayID);
    this.toBeDelayed = false;
    this.shouldUpdate();
  };
  componentDidMount() {
    this.startDelaying();
  }
  shouldComponentUpdate() {
    if (this.toBeDelayed) {
      this.startDelaying();
    }
    return true;
  }
  componentWillUnmount() {
    this.stopDelaying();
  }
  componentDidUpdate() {
    this.toBeDelayed = true;
  }
  render() {
    return !this.toBeDelayed ? this.props.children : null;
  }
}
OuiDelayRender.propTypes = {
  delay: PropTypes.number.isRequired
};
try {
  OuiDelayRender.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src3077135706/src/src/components/delay_render/delay_render.tsx',
    description: '',
    displayName: 'OuiDelayRender',
    methods: [],
    props: {
      delay: {
        defaultValue: {
          value: '500'
        },
        description: '',
        name: 'delay',
        parent: {
          fileName: 'src/src/components/delay_render/delay_render.tsx',
          name: 'OuiDelayRenderProps'
        },
        declarations: [{
          fileName: 'src/src/components/delay_render/delay_render.tsx',
          name: 'OuiDelayRenderProps'
        }],
        required: false,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['OuiDelayRenderProps']
  };
} catch (e) {}